import resolveDeployedConsent from 'api/pipelines/utils/resolveDeployedConsent';

export default function buildDeployedIntegrationsMap(deployedIntegrations) {
  return deployedIntegrations.reduce((deployedIntegrationsMap, integration) => {
    const { id: integrationId } = integration;

    /**
     * Tech Debt :: SP :: See `parseDeployedIntegration.js` for original tech debt comment
     *  Revisions deployed via the CLI may not have certain fields that an integration deployed via Ion would have
     *  As a result, the use here of of optional chaining reflects a band-aid to manage the heterogeneity here
     */
    const revisionId = integration.revision?.id;
    const revisionNumber = Number(integration.transformStages[0]?.data?.playbook.version) || null;

    const { consentCategoryCode, consentMode } = resolveDeployedConsent(integration.consent);

    const params = {
      endpointSchema: integration.endpointSchema?.params || [],
      connection: integration.connection.params,
      transformStage: integration.transformStages?.[0]?.data?.playbook?.params || [],
    };

    const deployedIntegration = {
      revisionId,
      revisionNumber,
      stagedForDelete: false,
      params,
      consentCategoryCode,
      consentMode,
      disabled: integration.disabled,
    };

    return {
      ...deployedIntegrationsMap,
      [integrationId]: deployedIntegration,
    };
  }, {});
}
